import { INPROCESS_EVENTS } from "common";
import { DialogHelper } from "helpers";
import history from "routers/history";

const messageChannel = new MessageChannel();

export const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      const url = `${process.env.PUBLIC_URL}/sw.js`;
      navigator.serviceWorker.register(url).then(() => {
        navigator.serviceWorker.controller?.postMessage(
          {
            type: INPROCESS_EVENTS.INIT_PORT,
          },
          [messageChannel.port1]
        );

        // Listen to the response
        messageChannel.port2.onmessage = (event) => {
          // Print the result
          console.log("Receive message from sw =>>", event.data);
          const { message, title, id } = event.data;
          playAlert();
          DialogHelper.open({
            title: title,
            message: message,
            isCancel: true,
            onConfirm: () => {
              navigator.serviceWorker.controller?.postMessage({
                ...event.data,
                type: "CLEAR_NOTIFICATION",
              });
              history.replace(
                process.env.PUBLIC_URL + "/inprocess-check/" + id
              );
              //dont know why have to do this
              history.push("/");
              history.go(-1);
              stopAlert();
            },
            onCancel: () => {
              navigator.serviceWorker.controller?.postMessage({
                ...event.data,
                type: "CANCEL_NOTIFICATION",
              });
              stopAlert();
            },
          });
        };
      });
    });
  }
};

const playAlert = () => {
  (document.getElementById("alert") as HTMLAudioElement).play();
};

const stopAlert = () => {
  (document.getElementById("alert") as HTMLAudioElement).pause();
};
